import { Box, SxProps, Theme, useTheme } from '@mui/material'
import { WeekdaysToggles } from '../../types/models'
import { lang } from '../../utils/lang'

export interface DaySelectorProps {
  value: WeekdaysToggles
  onChange: (value: WeekdaysToggles) => void
  sx?: SxProps<Theme>
}

export function DaySelector(props: DaySelectorProps): JSX.Element {
  const { value, sx, onChange } = props
  const theme = useTheme()

  const sxCommon: SxProps<Theme> = {
    display: 'inline-block',
    cursor: 'pointer',
    width: '2rem',
    height: '2rem',
    lineHeight: '2rem',
    fontsize: '0.875rem',
    fontWeight: 400,
    borderRadius: '1rem',
    mx: 0.5
  }

  const sxOn: SxProps<Theme> = {
    color: theme.palette.grey[900],
    backgroundColor: 'primary.main',
  }
  const sxOff: SxProps<Theme> = {
    color: 'white',
    backgroundColor: theme.palette.grey[600],
  }

  const onClick = (idx: number) => {
    value[idx] = !value[idx]
    onChange(value)
  }

  return (
    <Box sx={{
      textAlign: 'center',
      ...sx
    }}>
      {lang.dayLetters().map((letter, idx) => (
        <Box
          key={idx}
          component="span"
          className={value[idx] ? 'dayselector-on' : 'dayselector-off'}
          onClick={() => onClick(idx)}
          sx={value[idx] ? { ...sxCommon, ...sxOn } : { ...sxCommon, ...sxOff }}
        >
          {letter}
        </Box>
      ))}
    </Box>
  )
}
